import {
  DynamicPlanning,
  Milestone,
  TimestampInput,
  UpdateMilestoneInput,
} from '@lib/graphql/__generated__/graphql'
import path from 'ramda/src/path'
import { ENTITY_STATUS } from './constants'
import { REMINDER_TYPE_FEATURES } from './Dashboard/dashboardReminderUtil'
import { getDateFromTimeStamp, isValidDate } from './Date'
import { isServiceMilestone } from './milestones'

export const serializeMilestoneUpdate = ({
  label,
  name,
  position,
  id,
  duration,
  dynamicPlanner,
  executionDate,
  notes,
  targetDeadline,
  adjustedDuration,
}: Milestone) =>
  ({
    id,
    labelId: label?.id,
    duration,
    name,
    notes,
    position,
    dynamicPlanner: dynamicPlanner as TimestampInput,
    executionDate: executionDate as TimestampInput,
    targetDeadline: targetDeadline as TimestampInput,
    adjustedDuration,
  }) satisfies UpdateMilestoneInput

export const isDynamicPlannerEditable = (params) => {
  const { data } = params
  const task = data?.task

  return (
    !isServiceMilestone({ data: data?.milestone }) &&
    data?.status !== ENTITY_STATUS.CANCELED &&
    (isValidDate(task?.deadline)
      ? getDateFromTimeStamp(task.deadline).getTime() > new Date().getTime()
      : true)
  )
}

export const shouldRenderFeatureReminder = ({ reminderType, features }) => {
  const feature = REMINDER_TYPE_FEATURES[reminderType]

  return feature ? features.includes(feature) : true
}

export const getDynamicPlanningRowId = (data: DynamicPlanning) => {
  return (
    data?.milestone?.id ||
    data?.goal?.id ||
    data?.task?.id ||
    data?.project?.id ||
    data?.thread?.id ||
    data?.productionPlanningProject?.id ||
    data?.keyMilestonesProject?.id
  )
}

export const getProgressButtonCounters = (params) => ({
  all: path(['data', 'tasksMeta', 'tasksCount'])(params),
  done: path(['data', 'tasksMeta', 'tasksDone'])(params),
})
